import * as loadingState from '@dragonfruit/constants/loadingState';

export const RESEND_PHONE_VERIFICATION = 'RESEND_PHONE_VERIFICATION';
export const RESEND_PHONE_VERIFICATION_SUCCESS =
  'RESEND_PHONE_VERIFICATION_SUCCESS';
export const RESEND_PHONE_VERIFICATION_ERROR =
  'RESEND_PHONE_VERIFICATION_ERROR';

export const resendPhoneVerification = () => ({
  type: RESEND_PHONE_VERIFICATION,
});

export const resendPhoneVerificationSuccess = () => ({
  type: RESEND_PHONE_VERIFICATION_SUCCESS,
});

export const resendPhoneVerificationError = errorMessage => ({
  type: RESEND_PHONE_VERIFICATION_ERROR,
  payload: {
    errorMessage,
  },
});

const INIT_STATE = {
  resendPhoneVerificationStatus: loadingState.EMPTY,
  errorMessage: '',
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESEND_PHONE_VERIFICATION:
      return {
        ...state,
        resendPhoneVerificationStatus: loadingState.LOADING,
      };
    case RESEND_PHONE_VERIFICATION_SUCCESS:
      return {
        ...state,
        resendPhoneVerificationStatus: loadingState.READY,
      };
    case RESEND_PHONE_VERIFICATION_ERROR:
      return {
        ...state,
        resendPhoneVerificationStatus: loadingState.ERROR,
      };
    default:
      return state;
  }
};

export default reducer;

export const getResendPhoneVerificationStatus = state =>
  state.resendPhoneVerification.resendPhoneVerificationStatus;



// WEBPACK FOOTER //
// ./app/redux/resendPhoneVerification.js